import { render, staticRenderFns } from "./SkywayLoading.vue?vue&type=template&id=8350e9ca&"
import script from "./SkywayLoading.vue?vue&type=script&lang=js&"
export * from "./SkywayLoading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports